import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { AddCategoriiProiecteComponent } from '../../categorii-proiecte/add-categorii-proiecte/add-categorii-proiecte.component';
import { TaguriProiecteService } from '../taguri-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ITagAddPayload, ITagForm } from '../taguri-proiecte.interface';

@Component({
    selector: 'app-add-taguri-proiecte',
    templateUrl: './add-taguri-proiecte.component.html',
    styleUrls: ['./add-taguri-proiecte.component.scss']
})
export class AddTaguriProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddCategoriiProiecteComponent>,
        private taguriProiecteService: TaguriProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as ITagForm;
        const payload: ITagAddPayload = {
            name
        };

        this.taguriProiecteService
            .addTag(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
